<template>
  <b-overlay :show="isLoading" rounded="sm">
    <b-card
      bg-variant="secondary"
      text-variant="white"
      class="structure"
    >
      <div class="structure__title">Structure</div>
      <ul class="structure__three">
        <li>
          <div class="structure__main">
            <div>
              <svg viewBox="0 0 512 512">
                <path d="M469.333,85.333H249.75l-39.542-39.542c-2-2-4.708-3.125-7.542-3.125h-160C19.135,42.667,0,61.802,0,85.333v341.333c0,23.531,19.135,42.667,42.667,42.667h426.667c23.531,0,42.667-19.135,42.667-42.667V128C512,104.469,492.865,85.333,469.333,85.333z"/>
              </svg>
            </div>
            {{ monitorCurrent.monitor.name }}
          </div>
          <ul v-if="monitorStructure.length > 0" class="structure__chapters">
           <li v-for="chapter in monitorStructure" :key="chapter.id">
              <div class="structure__item">
                <div>
                  <svg viewBox="0 0 512 512">
                    <path d="M469.333,85.333H249.75l-39.542-39.542c-2-2-4.708-3.125-7.542-3.125h-160C19.135,42.667,0,61.802,0,85.333v341.333c0,23.531,19.135,42.667,42.667,42.667h426.667c23.531,0,42.667-19.135,42.667-42.667V128C512,104.469,492.865,85.333,469.333,85.333z"/>
                  </svg>
                </div>
                {{ chapter.name }}
              </div>
              <ul v-if="chapter.paragraphs" class="structure__paragraphs">
                <li v-for="paragraph in chapter.paragraphs" :key="paragraph.id">
                  <div class="structure__item">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 492.004 492.004"><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/></svg>
                    {{ paragraph.name }}
                  </div>
                </li>
              </ul>
           </li>
          </ul>
        </li>
      </ul>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'MonitorStructure',
  props: ['monitor'],
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters(["monitorCurrent", "monitorStructure"])
  },
  mounted() {
    this.isLoading = false;
  }
}
</script>

<style lang="scss" scoped>
.structure {
  
  &__title {
    text-transform: uppercase;
    margin-bottom: rem(12px);
  }

  &__three {
    list-style: none;
    margin: 0;
    padding: 0;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      &.structure__paragraphs {
        margin-bottom: rem(16px);
      }

      li {
        padding-left: rem(12px);   
      }
    }
  }

  &__main {
    margin-bottom: rem(8px);
    display: flex;
    align-items: center;

    svg {
      width: rem(12px);
      height: rem(12px);
      margin-right: rem(6px);
      fill: #fff;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-size: rem(12px);
    width: 100%;
    font-weight: 300;
    margin-bottom: rem(6px);

    svg {
      width: rem(12px);
      height: rem(12px);
      margin-right: rem(6px);
      fill: #fff;
    }
  }
}
</style>